import App from './App.svelte';
import { writable, Writable } from 'svelte/store';
// import "./main.css";
import './app.css';

import { addMessages, init } from 'svelte-i18n';

import en from './i18n/translation.json';
import { debugLog } from './lib/debug-log';
import 'tippy.js/dist/tippy.css';
import { initializeUtmTracking } from './utils/utmTracking';

// Initialize persistent UTM tracking and interceptor
initializeUtmTracking();



addMessages('en', en);

export const errorStore: Writable<{
  message: any;
  source: any;
  lineno: any;
  colno: any;
  error: any;
} | null> = writable(null);

window.onerror = (message, source, lineno, colno, error) => {
  // if the location has /admin skip
  if (
    window.location.pathname.includes('/admin') ||
    window.location.pathname.includes('/step/5')
  ) {
    return;
  }
  errorStore.set({ message, source, lineno, colno, error });
};

window.onunhandledrejection = (event) => {
  // if the location has /admin skip
  if (window.location.pathname.includes('/admin')) {
    return;
  }
  debugLog('event', event);
  errorStore.set({
    message: event.reason,
    source: event.reason,
    lineno: event.reason,
    colno: event.reason,
    error: event.reason,
  });
};

window.addEventListener('error', (event) => {
  // if the location has /admin skip
  if (window.location.pathname.includes('/admin')) {
    return;
  }
  errorStore.set({
    message: event.message,
    source: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });
});

window.addEventListener('unhandledrejection', function (event) {
  // if the location has /admin skip
  if (window.location.pathname.includes('/admin')) {
    return;
  }
  window.addEventListener('error', (event) => {
    errorStore.set({
      message: event.message,
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
    });
  });
});

init({
  fallbackLocale: 'en',
  initialLocale: 'en',
});

new App({
  target: document.getElementById('app')!,
});
